export default "__VITE_ASSET__89f1b4aa__"